import { useCallback } from 'react';
export const useOnEndIconClick = ({ onClear, setValue, }) => {
    const onEndIconClick = useCallback(() => {
        if (onClear) {
            onClear();
            setValue('');
        }
    }, [onClear, setValue]);
    return onEndIconClick;
};
